import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import AuthCard from "@/components/AuthCard";
import NewPasswordForm from "@/components/NewPasswordForm";
import { apiError } from "@/lib/errors";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";

  const submit = async (pw) => {
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <AuthCard overline="Account Recovery" title="RESET PASSWORD" testid="reset-password-page">
      {token ? <NewPasswordForm onSubmit={submit} submitLabel="RESET PASSWORD"/> : (
        <p className="text-sm text-red-600" data-testid="reset-missing-token">This reset link is missing its token.</p>
      )}
      <Link to="/login" className="block mt-6 text-sm text-slate-600 hover:text-[#0A1128]">← Back to sign in</Link>
    </AuthCard>
  );
}
